<template>
  <div class="week-calendar">
    <div class="week-calendar-header">
      <div class="week-calendar-controls">
        <icon
          class="ms-text"
          size="22"
          type="ios-arrow-back"
          @click="index--"
        />
        <icon
          class="ms-text"
          size="22"
          type="ios-arrow-forward"
          @click="index++"
        />
      </div>
      <div class="week-calendar-date">
        <span class="ms-subhead"> {{ month }} {{ year }} </span>
      </div>
    </div>
    <div class="week-calendar-container">
      <card
        dis-hover
        :padding="8"
        :class="['wc-day', day.today ? 'today' : '']"
        v-for="day in weekDays"
        :key="day.index"
      >
        <div class="wc-day-header">
          <span class="ms-subhead">
            {{ day.date }} {{ day.today ? "(сегодня)" : null }}
          </span>
          <span class="ms-help">{{ day.title }}</span>
        </div>
        <div class="wc-day-container">
          <ul class="wc-day-events" v-if="getTasks(day.value).length">
            <event-item
              v-for="event in getTasks(day.value)"
              :key="event.key"
              :event="event"
            />
          </ul>
          <div v-else class="ms-nodata ms-help">
            Задачи отсутствуют
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import cloneDeep from 'lodash.clonedeep'
import EventItem from '../tasks/event-item'
import { getStyleObject } from '../tools'

const weekDays = [
  { index: 1, title: 'пн', date: '10.02.2019', value: null, today: false },
  { index: 2, title: 'вт', date: '10.02.2019', value: null, today: false },
  { index: 3, title: 'ср', date: '10.02.2019', value: null, today: false },
  { index: 4, title: 'чт', date: '10.02.2019', value: null, today: false },
  { index: 5, title: 'пт', date: '10.02.2019', value: null, today: false },
  { index: 6, title: 'сб', date: '10.02.2019', value: null, today: false },
  { index: 7, title: 'вс', date: '10.02.2019', value: null, today: false }
]

export default {
  props: ['stickers', 'tasks', 'holidays'],
  components: {
    EventItem
  },
  data () {
    return {
      month: moment().format('MMMM'),
      year: moment().format('YYYY'),
      index: 0,
      weekDays
    }
  },
  watch: {
    index: function (index) {
      this.createWeekDays(index)
    }
  },
  methods: {
    getWeekDay (day) {
      const index = Number(day.format('d'))

      if (index === 0) return 7

      return index
    },
    createWeekDays (index = 0) {
      let currentDay

      if (index === 0) currentDay = moment()
      else if (index < 0) {
        currentDay = moment().subtract(Math.abs(index), 'weeks')
      } else currentDay = moment().add(index, 'weeks')

      const weekDay = this.getWeekDay(currentDay)
      this.weekDays = this.weekDays.map(d => {
        const diff = d.index - weekDay
        let today = false
        let value

        if (diff === 0) {
          value = cloneDeep(currentDay)
          today = index === 0
        } else if (diff > 0) {
          value = cloneDeep(currentDay).add(diff, 'days')
        } else {
          value = cloneDeep(currentDay).subtract(Math.abs(diff), 'days')
        }

        return {
          ...d,
          date: value.format('D'),
          value,
          today
        }
      })
      this.month = currentDay.format('MMMM')
      this.year = currentDay.format('YYYY')
    },
    getTasks (date) {
      return this.tasks
        .map(t => ({
          id: t.id,
          ...getStyleObject(t)
        }))
        .filter(t => {
          const { dates } = t

          if (Array.isArray(dates)) {
            const { start, end } = dates[0]

            return moment(start).unix() <= date.unix() && date.unix() <= moment(end).unix()
          } else {
            return moment(dates).format('l') === date.format('l')
          }
        })
    }
  },
  created () {
    this.createWeekDays(this.index)
  }
}
</script>

<style lang="less">
.week-calendar {
  width: 100%;
  height: calc(100vh - 148px);
  padding: 8px;
  border-radius: 4px;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;

  &-controls {
    padding: 3px;
    padding-left: 5px;

    .ivu-icon {
      cursor: pointer;

      &:last-child {
        margin-left: 11px;
      }
    }
  }

  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-right: 10px;
    padding-top: 2px;
  }

  &-container {
    display: flex;
    flex: 1;
  }

  .wc-day {
    flex: 1;

    &-header {
      display: flex;
      // flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .ms-help {
        margin-bottom: 2px;
        font-size: 14px;
      }
    }

    &-events {
      max-height: calc(100vh - 270px);
      overflow: auto;
    }

    &.today {
      border-color: @primary-color !important;
    }

    &:not(:first-child) {
      margin-left: 8px;
    }
  }
}

.light {
  .week-calendar {
    background: #f5f7f9;
    border-color: #e8eaec;
  }
}
.dark {
  .week-calendar {
    background: @dt-dark-bg;
    border-color: rgba(@dt-dark-primary, 1);
  }
}
</style>
